import AppRouter from './router/AppRouter';

const App = () => <AppRouter />;

export default App;
